@if (show || (isLoading$ | async)) {
  @if (inline) {
    <div class="loader-inline" [class]="'loader-' + size">
      <div class="spinner"></div>
      @if (message) {
        <span class="loader-message">{{ message }}</span>
      }
    </div>
  } @else {
    <div class="loader-overlay">
      <div class="loader-card">
        <span class="loader-brand">E.A.S.Y.&nbsp;<span class="brand-accent">Liens</span></span>
        <div class="loader-divider"></div>
        <div class="spinner"></div>
        <span class="loader-message">{{ message || 'Loading…' }}</span>
      </div>
    </div>
  }
}
